import { createSlice } from '@reduxjs/toolkit';
import {Referrals} from "./Referrals";

const ReferralsSlice = createSlice({
    name: 'main',
    initialState: Referrals,
    reducers: {
        addItem: (state, action) => {
            state.push(action.payload);
        },
    },
});

export const { addItem } = ReferralsSlice.actions;
export default ReferralsSlice;